module.exports = __webpack_public_path__ + "img/fenxiang.513978b1.png";